import { useFeatureGating } from '../hooks/useFeatureGating';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Lock, ArrowLeft } from 'lucide-react';

export function FeatureGate({ feature, children }) {
  const { hasFeature, FEATURE_LABELS } = useFeatureGating();
  const { lang } = useLanguage();
  const navigate = useNavigate();

  if (hasFeature(feature)) {
    return children;
  }

  const label = FEATURE_LABELS[feature];
  const name = label ? (lang === 'it' ? label.it : label.en) : feature;

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="feature-gate-block">
      <div className="text-center max-w-md mx-auto p-8">
        <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-6">
          <Lock className="w-8 h-8 text-amber-600" />
        </div>
        <h2 className="text-xl font-semibold text-stone-800 mb-2">
          {lang === 'it' ? 'Funzionalità Premium' : 'Premium Feature'}
        </h2>
        <p className="text-stone-500 mb-1 font-medium">{name}</p>
        <p className="text-sm text-stone-400 mb-6">
          {lang === 'it'
            ? 'Questa funzionalità non è inclusa nel tuo piano attuale. Contatta l\'amministratore per effettuare l\'upgrade.'
            : 'This feature is not included in your current plan. Contact your administrator to upgrade.'}
        </p>
        <Button onClick={() => navigate(-1)} variant="outline" data-testid="feature-gate-back-btn">
          <ArrowLeft className="w-4 h-4 mr-2" />
          {lang === 'it' ? 'Torna indietro' : 'Go back'}
        </Button>
      </div>
    </div>
  );
}
